import { env } from './env';
import { runtime, Runtime } from './envRuntime';

// 判断是否是 SubErrorType 类型
function isSubErrorType(error: any): error is SubErrorType {
  return typeof error.name === 'string' && typeof error.msg === 'object';
}

/**
 * Name: CAT异常监控
 */
class Monitor {
  private config: any = {};

  private readonly isDev: boolean = true;

  constructor(isDev: boolean) {
    if (!Owl) {
      return;
    }
    this.isDev = isDev;
    this.init();
    Owl.start(this.config);
  }

  init() {
    this.config = {
      project: 'pay-ibalance',
      pageUrl: `${window.location.origin}${window.location.pathname}`,
      devMode: this.isDev,
      resource: {
        sampleApi: 1,
        delay: 0,
      },
      page: {
        auto: true,
        sample: 1,
        delay: 0,
        sensoryIndex: false,
      },
      error: {
        sample: 1,
        combo: false,
      },
      ajax: {
        flag: true,
        duration: 8000,
      },
      metric: {
        sample: 1,
        combo: true,
      },
      onErrorPush: (error: any) => {
        return error.updateTags({
          ...env.commonParams,
          ...this.defaultInfo,
        });
      },
    };
  }

  get defaultInfo() {
    return {
      scene: env.scene,
      utmSource: env.utmSource,
      campaignId: env.campaignId,
      ...env.commonParams,
    };
  }

  captureMessage(error: string | SubErrorType, config = {} as ICatErrorModel) {
    const baseConfig: ICatErrorModel = {
      level: 'info',
      category: 'custom_info',
    };

    // 若 error 类型是 SubErrorType 且 error.msg 类型是 Error
    if (isSubErrorType(error) && error.msg instanceof Error) {
      error.msg = error.msg.stack;
    }

    // 上报 自定义类别 错误异常
    Owl.addError(error, {
      ...baseConfig,
      ...config,
    });
  }

  captureJSErrorMessage(message: string | SubErrorType, tags?: any) {
    this.captureMessage(message, {
      tags,
      level: 'error',
      category: 'jsError',
    });
  }

  captureAjaxErrorMessage(message: string | SubErrorType, tags?: any) {
    this.captureMessage(message, {
      tags,
      level: 'error',
      category: 'ajaxError',
    });
  }

  captureError(error: string | SubErrorType, config = {} as ICatErrorModel) {
    const baseConfig: ICatErrorModel = {
      level: 'error',
      category: 'customError',
    };

    // 上报 自定义类别 错误异常
    Owl.addError(error, {
      ...baseConfig,
      ...config,
    });
  }

  reportMetric(key: string, tags = {}, value?: any): void {
    const metricManager = Owl.metricManager;
    metricManager.setTags({
      ...this.defaultInfo,
      ...tags,
    });
    metricManager.setMetric(key, value || 1);
    // 强制上报所有
    metricManager.report();
  }

  sendPoint() {
    // 在CAT后台展示时index N对应的是自定义性能点N+1
    if (Owl && Owl.addPoint && Owl.sendPoints) {
      Owl.addPoint({
        position: 20,
      });
      // 发送数据
      Owl.sendPoints();
      (window as any).haveReportedTTI = true;
    }
  }

  sendPointCustomApi(tags: any = {}) {
    const { position, duration } = tags;
    // 在CAT后台展示时index N对应的是自定义性能点N+1
    if ((window as any)[`reported${position}`]) return;
    if (Owl && Owl.addPoint && Owl.sendPoints) {
      Owl.addPoint({
        position,
        duration: duration || Date.now() - window.performance.timing.navigationStart,
      });
      // 发送数据
      Owl.sendPoints();
      (window as any)[`reported${position}`] = true;
    }
  }
}

const isProduct = runtime === Runtime.Prod;
export const monitor = new Monitor(!isProduct);
